// curriculum_filter_controller.js
import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["card"];
  
  connect() {
    console.log("Curriculum Filter Controller Connected");
    this.currentFilter = { pcp: 'all', acp: 'all' };
  }
  
  filterAll(event) {
    const program = event.currentTarget.dataset.program;
    this.setActiveButton(event.currentTarget, program);
    this.currentFilter[program] = 'all';
    this.applyFilter(program);
  }
  
  filterSimulations(event) {
    const program = event.currentTarget.dataset.program;
    this.setActiveButton(event.currentTarget, program);
    this.currentFilter[program] = 'simulations';
    this.applyFilter(program);
  }
  
  filterSkills(event) {
    const program = event.currentTarget.dataset.program;
    this.setActiveButton(event.currentTarget, program);
    this.currentFilter[program] = 'skills';
    this.applyFilter(program);
  }
  
  filterNone(event) {
    const program = event.currentTarget.dataset.program;
    this.setActiveButton(event.currentTarget, program);
    this.currentFilter[program] = 'none';
    this.applyFilter(program);
  }
  
  setActiveButton(clickedButton, program) {
    // Remove active class from all buttons in this program's section
    const section = this.element.querySelector(`.curriculum-section[data-program="${program}"]`);
    if (section) {
      section.querySelectorAll('.filter-badge').forEach(button => {
        button.classList.remove('active');
      });
    }
    
    // Add active class to clicked button
    clickedButton.classList.add('active');
  }
  
  applyFilter(program) {
    const filter = this.currentFilter[program];
    let visibleCount = 0;
    
    console.log(`Filtering ${program} with filter: ${filter}`);
    console.log(`Total cards found: ${this.cardTargets.length}`);
    
    this.cardTargets.forEach(card => {
      // Only filter cards for the specified program
      if (card.dataset.program !== program) {
        return;
      }
      
      console.log('Card data:', {
        program: card.dataset.program,
        hasSimulations: card.dataset.hasSimulations,
        hasSkills: card.dataset.hasSkills,
        hasNone: card.dataset.hasNone
      });
      
      let shouldShow = false;
      
      switch(filter) {
        case 'all':
          shouldShow = true;
          break;
        case 'simulations':
          shouldShow = card.dataset.hasSimulations === 'true';
          break;
        case 'skills':
          shouldShow = card.dataset.hasSkills === 'true';
          break;
        case 'none':
          shouldShow = card.dataset.hasNone === 'true';
          break;
      }
      
      console.log(`Should show: ${shouldShow}`);
      
      if (shouldShow) {
        card.style.display = 'block';
        card.style.animation = 'fadeInUp 0.3s ease-out';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });
    
    console.log(`Visible count: ${visibleCount}`);
    
    // Update the section to show count of visible items
    this.updateVisibleCount(program, visibleCount);
  }
  
  updateVisibleCount(program, count) {
    const section = this.element.querySelector(`.curriculum-section[data-program="${program}"]`);
    if (section) {
      // Check if a count indicator already exists
      let countIndicator = section.querySelector('.filter-result-count');
      
      if (!countIndicator) {
        countIndicator = document.createElement('div');
        countIndicator.className = 'filter-result-count';
        const grid = section.querySelector('.nocp-cards-grid');
        if (grid) {
          grid.parentNode.insertBefore(countIndicator, grid);
        }
      }
      
      const filter = this.currentFilter[program];
      if (filter === 'all') {
        countIndicator.style.display = 'none';
      } else {
        countIndicator.style.display = 'block';
        countIndicator.innerHTML = `<i class="fa fa-filter"></i> Showing ${count} competenc${count === 1 ? 'y' : 'ies'}`;
      }
    }
  }
}

